module.exports = __webpack_public_path__ + "static/media/buttongradient.c919e56c.png";